import { render, staticRenderFns } from "./MaterialCheck.vue?vue&type=template&id=08200a4f&scoped=true"
import script from "./MaterialCheck.vue?vue&type=script&lang=js"
export * from "./MaterialCheck.vue?vue&type=script&lang=js"
import style0 from "./MaterialCheck.vue?vue&type=style&index=0&id=08200a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08200a4f",
  null
  
)

export default component.exports